import { render } from "./Cohorte.vue?vue&type=template&id=fc980998&scoped=true"
import script from "./Cohorte.vue?vue&type=script&lang=js"
export * from "./Cohorte.vue?vue&type=script&lang=js"

import "./Cohorte.vue?vue&type=style&index=0&id=fc980998&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc980998"]])

export default __exports__